module.exports = __webpack_public_path__ + "static/media/analysis.b0baa682.svg";